module.exports = __webpack_public_path__ + "static_pc/img/30.a1509a60.jpeg";